// export const Address =
//   "آدرس: بلوار دریا، بین میدان کوثر و بلوار سعادت آباد، خیابان گلها، نبش توحید اول، پلاک ۳، واحد ۱";

// export const phone_number = "021-91004004";
export const email = "info@invex.ir";

export const Address =
  "تهران، بزرگراه کردستان، خروجی ملاصدرا، بن بست یکم، پلاک ۱۴";

export const phone_number = "021-92009103";
